module.exports = __webpack_public_path__ + "img/guoqi.9b783861.png";